import React, {useEffect, useState} from "react";
import Switch from "react-bootstrap-switch";
import ReactJson from "react-json-view";
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";
import { useForm } from "react-hook-form";
import {connect, useSelector} from "react-redux";
import * as Yup from "yup";



// components
import {
    ButtonCancel, CustomMiniButtonX,
} from "../../../components/buttons/buttonsActions";

// labels
import { FORM } from "../../../components/i18n/i18n";
import {showLoader} from "../../../components/loader/loader";
import {xwitchLogService} from "../../../jwt/_services/bi/xwitchLogService";
import {TT_CLOSE} from "../../../components/i18n/toolTips";

// actions

// components

// services & providers

const XwitchLogForm = props => {

    const xwitchLog = { id : props?.match?.params?.id  }
    const [request, setRequest] = useState("{}");
    const [response, setResponse] = useState("{}");

    const [showDetailedJson, setShowDetailedJson] = useState(true);
    const [loading, setLoading] = useState(false );
    const [domainObject, setDomainObject] = useState(null );

    useEffect(() => {
        if (props?.match?.params?.id) {
            getXwitchLogData(props?.match?.params?.id);
        }
    }, [props?.match?.params?.id]);

    useEffect(() => {
        try {
            setRequest(JSON.parse(domainObject?.request));
        } catch (ignored) {
            const something = JSON.parse('{ "request":"' + domainObject?.request + '"}')
            setRequest(something);
        }
        try {
            setResponse(JSON.parse(domainObject?.response));
        } catch (ignored) {
            try {
                const something = JSON.parse('{ "response":"' + domainObject?.response + '"}')
                setResponse(something);
            } catch (ex) {
                console.log(ex);
                setResponse("");
            }
        }
    }, [domainObject]);

    const validationSchema = Yup.object().shape({
    });

    const {register, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            transactionId: domainObject?.transactionId,
            salesId: domainObject?.salesId,
            request: domainObject?.request,
            response: domainObject?.response,
            voucherResponse: domainObject?.voucherResponse,

            amount: domainObject?.amount,
            exchange: domainObject?.exchange,
            amountUSD: domainObject?.amountUSD,
            currency: domainObject?.currency,
            clientName: domainObject?.clientName,

            paymentStatus: domainObject?.paymentStatus,
            registerDate: domainObject?.registerDate,
            correlationId: domainObject?.correlationId,
            message: domainObject?.message,
            os: domainObject?.os,
            app: domainObject?.app,
            appVersion: domainObject?.appVersion,
            deviceModel: domainObject?.deviceModel,
            deviceBrand: domainObject?.deviceBrand,
            transactionStatus: domainObject?.transactionStatus,
        }
    });

    const getXwitchLogData = (id) => {
        setLoading(true);
        xwitchLogService.getItem(id)
            .then((response) => {
                if (response !== null) {
                    setDomainObject(response);
                    reset(response);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    }


    return (<>
            {loading && showLoader()}
            <Card className={''}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-edit mr-2"/>
                    {FORM}
                </CardTitle>

                <CardBody className={''}>
                    <Form >
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label>Transaction ID</Label>
                                    <Input type="text"
                                           name="transactionId"
                                           innerRef={register}
                                           disabled={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Fecha de registro</Label>
                                    <Input type="text"
                                           name="registerDate"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label>Usuario</Label>
                                    <Input type="text"
                                           name="clientName"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Id de venta</Label>
                                    <Input type="text"
                                           name="salesId"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Monto</Label>
                                    <Input type="text"
                                           name="amount"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Moneda</Label>
                                    <Input type="text"
                                           name="currency"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Tipo de cambio</Label>
                                    <Input type="text"
                                           name="exchange"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Monto USD</Label>
                                    <Input type="text"
                                           name="amountUSD"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Estatus Pago</Label>
                                    <Input type="text"
                                           name="paymentStatus"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Aplicación</Label>
                                    <Input type="text"
                                           name="app"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Versión</Label>
                                    <Input type="text"
                                           name="appVersion"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label>Dispositivo</Label>
                                    <Input type="text"
                                           name="deviceModel"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="1"></Col>
                            <Col md="2"></Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label >Ver como :</Label><br/>
                                    <Switch animate={true} offText={"Cadena"} onText={"JSON"}
                                            innerRef={register}
                                            onChange={_ => setShowDetailedJson(!showDetailedJson)}
                                            value={showDetailedJson}/>
                                </FormGroup>
                            </Col>
                        </Row>
                        {
                            showDetailedJson ?
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>Solicitud (JSON)</Label>
                                            <ReactJson src={request} name={'request'} displayDataTypes={false} collapsed={true}/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>Respuesta (JSON)</Label>
                                            <ReactJson src={response} name={'response'} displayDataTypes={false}/>
                                        </FormGroup>
                                    </Col>
                                </Row> :
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>Solicitud (JSON)</Label>
                                            <Input type="textarea" name="request"
                                                   rows="20"
                                                   innerRef={register}
                                                   disabled={true}/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>Respuesta (JSON)</Label>
                                            <Input type="textarea" name="response"
                                                   rows="20"
                                                   innerRef={register}
                                                   disabled={true}/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                        }
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label>Respuesta cupon unificado (JSON)</Label>
                                    <Input type="text" name="voucherResponse"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
        </>
    )
}

export default XwitchLogForm